import { useBrand, safeAssetUrl } from "../lib/brand";
import { cn } from "@cm/ui";

/**
 * Logo da marca do domínio (runtime). Sem imagem configurada, usa a inicial + nome (whitelabel sem logo).
 * tone="light" usa a versão para fundo escuro quando existir.
 */
export function BrandLogo({ variant = "full", tone = "dark", className }: { variant?: "full" | "mark"; tone?: "dark" | "light"; className?: string }) {
  const brand = useBrand();
  const t = brand.theme ?? {};
  const name = t.logoText ?? brand.name;
  const full = safeAssetUrl(tone === "light" ? t.logoLightUrl ?? t.logoUrl : t.logoUrl);
  const mark = safeAssetUrl(t.markUrl);
  if (variant === "full" && full) return <img src={full} alt={name} className={cn("h-7 w-auto object-contain", className)} />;
  if (variant === "mark" && mark) return <img src={mark} alt={name} className={cn("h-8 w-8 object-contain", className)} />;
  return (
    <span className={cn("inline-flex items-center gap-2 font-semibold", tone === "light" ? "text-white" : "text-fg", className)}>
      {mark ? (
        <img src={mark} alt="" aria-hidden className="h-8 w-8 object-contain" />
      ) : (
        <span className="grid h-8 w-8 place-items-center rounded-md bg-brand text-sm font-bold text-brand-fg" aria-hidden>
          {name.slice(0, 1)}
        </span>
      )}
      {variant === "full" && <span className="truncate">{name}</span>}
    </span>
  );
}
